import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useTheme } from "@emotion/react";
import FormLogin from "../Patient/FormLogin";
import FormGuest from "../Patient/FormReservationGuestImagenologia";
import { useRecoilState, useRecoilValue } from "recoil";
import { activeTabReservationState } from "./state/atoms";
import { valuesFormReservationGuestState, valuesFormReservationUserState } from "src/Patient/state/atoms";
import React, { useState, useEffect }  from 'react';
import TabsCustom from "src/shared/components/tabs/TabsCustom";
import ManageStorage from "src/shared/global/manageStorage";

export default function TabsReservation() {
  const [activeTabReservation, setActiveTabReservation] = useRecoilState(
    activeTabReservationState
  );
  const theme = useTheme();
  const valuesFormReservationGuest = useRecoilValue(
    valuesFormReservationGuestState
  );
  const valuesFormReservationUser = useRecoilValue(
    valuesFormReservationUserState
  );
  const totem = ManageStorage.getValueFromStorage("TOTEM");

  const [tabsDisabled, setTabsDisabled] = useState({
    one: false,
    two: false,
  });

  const handleChangeTab = (event, newValue) => {
    setActiveTabReservation(newValue);
  };

  useEffect(() => {
    if (Object.values(valuesFormReservationGuest).some((x) => x !== "")) {
      setTabsDisabled({
        ...tabsDisabled,
        one: true,
      });
    } else {
      setTabsDisabled({
        ...tabsDisabled,
        one: false,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valuesFormReservationGuest]);

  useEffect(() => {
    if (Object.values(valuesFormReservationUser).some((x) => x !== "")) {
      setTabsDisabled({
        ...tabsDisabled,
        two: true,
      });
    } else {
      setTabsDisabled({
        ...tabsDisabled,
        two: false,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valuesFormReservationUser]);

  useEffect(() => {
    if (totem === "OK") {
      setTabsDisabled({
        one: true,
        two: false,
      });
    } 
  }, []);

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={activeTabReservation}>
        <Box>
          {totem && totem === "OK" ? (
            <TabsCustom
              theme={theme}
              onChange={handleChangeTab}
              aria-label="lab API tabs example"
            >
              <Tab label="Como invitado" value="2" />
            </TabsCustom>
          ) : (
            <TabsCustom
              theme={theme}
              onChange={handleChangeTab}
              aria-label="lab API tabs example"
            >
              <Tab
                label="Como invitado"
                value="2"
                disabled={tabsDisabled["two"]}
              />
              {/* <Tab
                label="Con cuenta"
                value="1"
                disabled={tabsDisabled["one"]}
              /> */}
            </TabsCustom>
          )}

          {/* <TabsCustom theme={theme} onChange={handleChangeTab} aria-label="lab API tabs example">
          <Tab label="Como invitado" value="2" disabled={tabsDisabled["two"]} />
          <Tab label="Con cuenta" value="1" disabled={tabsDisabled["one"]} />
          </TabsCustom> */}
        </Box>
        <TabPanel value="1">
          <FormLogin xs={12} sm={6} />
        </TabPanel>
        <TabPanel value="2">
          <FormGuest />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
